enum InputType {
  Text = "text",
  File = "file",
}

export default InputType;
